

export const checkEnglishName = (rule, value, callback)=> {
    if(value) {
        let reg = new RegExp("^[a-zA-Z]+$")
        if(!reg.test(value)) {
            callback(new Error('输入内容必须纯英文'))
        }else {
            callback();
        }
    }
    callback();
}
export function checkPwd (rule, value, callback) {
    var reg = /^[a-zA-Z]([-_a-zA-Z0-9]{5,17})$/
    if (value) {
      if (!reg.test(value)) {
        callback(new Error('长度在6-20之间，以字母开头且只能包含字母和数字'));
      } else {
        callback();
      }
    }
    callback();
}

export const checkPhone = (rule, value, callback) => {
  let phoneReg = /^1[3456789]\d{9}$/
  if (phoneReg.test(value)) {
    callback()
  } else {
    callback(new Error('手机号格式错误'))
  }
}

// export function checkCardId (rule,value,callback,itemValue) {
//   if (itemValue === '1') {
//     let cardReg = /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/
//     if (cardReg.test(value)) {
//       callback()
//     } else {
//       callback(new Error('身份证格式错误'))
//     }
//   } else {
//     callback()
//   }
// }

export function checkCardId (rule,value,callback,itemValue) {
  if (itemValue === '1') {
    if (checkidnumber(value)) {
      callback()
    } else {
      callback(new Error('身份证格式错误'))
    }
  } else {
    callback()
  }
}

export function checkPwd_pure (value) {
  var reg = /^[a-zA-Z]([-_a-zA-Z0-9]{5,17})$/
    
  return reg.test(value)
    
}

// 身份证校验
export function checkidnumber (value) {
  value = value.toUpperCase(); //身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X。
  if (!(/(^\d{15}$)|(^\d{17}([0-9]|X)$)/.test(value))) {
      //alert('输入的身份证号长度不对，或者号码不符合规定！\n15位号码应全为数字，18位号码末位可以为数字或X。');
      return false;
  } //校验位按照ISO 7064:1983.MOD 11-2的规定生成，X可以认为是数字10。
  //下面分别分析出生日期和校验位
  var len, re;
  len = value.length;
  if (len == 15) {
      re = new RegExp(/^(\d{6})(\d{2})(\d{2})(\d{2})(\d{3})$/);
      var arrSplit = value.match(re); //检查生日日期是否正确
      var dtmBirth = new Date('19' + arrSplit[2] + '/' + arrSplit[3] + '/' + arrSplit[4]);
      var bGoodDay;
      bGoodDay = (dtmBirth.getYear() == Number(arrSplit[2])) && ((dtmBirth.getMonth() + 1) == Number(arrSplit[3])) && (dtmBirth.getDate() == Number(arrSplit[4]));
      if (!bGoodDay) {
          //alert('输入的身份证号里出生日期不对！');
          return false;
      } else { //将15位身份证转成18位 //校验位按照ISO 7064:1983.MOD 11-2的规定生成，X可以认为是数字10。
          var arrInt = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2);
          var arrCh = new Array('1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2');
          var nTemp = 0,
              i;
          value = value.substr(0, 6) + '19' + value.substr(6, value.length - 6);
          for (i = 0; i < 17; i++) {
              nTemp += value.substr(i, 1) * arrInt[i];
          }
          value += arrCh[nTemp % 11];
          return true;
      }
  }
  if (len == 18) {
      re = new RegExp(/^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X)$/);
      var arrSplit = value.match(re); //检查生日日期是否正确
      var dtmBirth = new Date(arrSplit[2] + "/" + arrSplit[3] + "/" + arrSplit[4]);
      var bGoodDay;
      bGoodDay = (dtmBirth.getFullYear() == Number(arrSplit[2])) && ((dtmBirth.getMonth() + 1) == Number(arrSplit[3])) && (dtmBirth.getDate() == Number(arrSplit[4]));
      if (!bGoodDay) {
          //alert(dtmBirth.getYear());
          //alert(arrSplit[2]);
          //alert('输入的身份证号里出生日期不对！');
          return false;
      } else { //检验18位身份证的校验码是否正确。 //校验位按照ISO 7064:1983.MOD 11-2的规定生成，X可以认为是数字10。
          var valnum;
          var arrInt = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2);
          var arrCh = new Array('1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2');
          var nTemp = 0,
              i;
          for (i = 0; i < 17; i++) {
              nTemp += value.substr(i, 1) * arrInt[i];
          }
          valnum = arrCh[nTemp % 11];
          if (valnum != value.substr(17, 1)) {
              //alert('18位身份证的校验码不正确！应该为：' + valnum);
              return false;
          }
          return true;
      }
  }
}

// 纯数字校验
export function checkNumber (rule, value, callback, max) {
  // if (!value) { return callback(new Error('请输入'))}
  if (isNaN(Number(value))) {
    return callback(new Error('请输入数值'))
  }
  if (!max || max && isNaN(Number(max))) {
    max = Number.MAX_VALUE
  }
  if (value > max) {
    callback(new Error(`超过最大值${max}，请输入有效数值`))
  } else {
    callback()
  }
}


